<template>
<div>
  <Header />
  <LoadingDialog
    ref="LoadingDialog"
    message="Loading data..."
    specific
  />
  <v-container grid-list-md fluid class="container-style">
    <div class="container-header">
      <span>Student Detail</span>
    </div>

    <v-layout>
      <v-flex xs12>
        <v-card class="no-shadow-print">
          <div>
            <div class="hide-on-view" style="text-align: center;">
              <img :src="require('@/assets/img/logo.png')" style="width:150px;">
            </div>
            <v-toolbar flat color="white" class="pt-2" style="margin-top: 21px;">
              <v-layout row wrap>
                <v-flex xs8 md4 class="title" style="margin-top: 40px;">
                  <v-text-field
                    label="LRN"
                    :value="student.lrn"
                    disabled
                    class="title font-weight-black disabled-field"
                  ></v-text-field>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs4 md4 v-if="student.admin_notes">
                  <v-chip>
                    <v-avatar class="red darken-4"><v-icon>warning</v-icon></v-avatar>
                    {{ student.admin_notes }}
                  </v-chip>
                </v-flex>
                <v-spacer></v-spacer>
                <v-btn color="#091D3B" outline @click="cancel" class="hide-on-print">Back</v-btn>
                <v-btn class="button-style-blue hide-on-print" @click="print">Print</v-btn>
                <v-btn class="button-style-blue hide-on-print" @click="updateStudent">Edit</v-btn>
                <v-btn v-if="selectedEnrollment" class="button-style-blue hide-on-print" :href="parentPortalUrl" target="_blank">parent Portal
                  <v-icon style="vertical-align: middle; margin-left: 5px">mdi-arrow-top-right</v-icon>
                </v-btn>
              </v-layout>
            </v-toolbar>
          </div>
          <v-container grid-list-md class="fluid-full">
            <v-layout row wrap>
              <v-flex xs12 class="mb-1">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Student Details</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Last Name"
                              :value="student.last_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="First Name"
                              :value="student.first_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Middle Name"
                              :value="student.middle_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Address"
                              :value="student.address"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Birthday"
                              :value="computeAge"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Gender"
                              :value="student.gender_display"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Religion"
                              :value="student.religion"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Telephone Number"
                              :value="student.telephone_number"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Mobile Number"
                              :value="student.mobile_number"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Nationality"
                              :value="student.nationality"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 class="mb-1">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Parents Information</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Father"
                              :value="student.father_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Occupation"
                              :value="student.father_occupation"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Company"
                              :value="student.father_company"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Mother"
                              :value="student.mother_name"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Occupation"
                              :value="student.mother_occupation"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 md4>
                            <v-text-field
                              label="Company"
                              :value="student.mother_company"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>

                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 class="mb-1 pagebreak">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Other Informations</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-text-field
                              label="Previous School"
                              :value="student.previous_school"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field
                              label="Language spoken at home"
                              :value="student.language_spoken_at_home"
                              disabled
                              class="disabled-field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              label="Special Information about child (allergies, handicaps, food, etc.)"
                              :value="student.special_information"
                              disabled
                              rows="1"
                              auto-grow
                              class="disabled-field"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 md6 class="mb-1 pagebreak">
                <v-card>
                  <v-toolbar flat color="white" class="pt-2">
                    <span class="title"><strong>Documents</strong></span>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-card-title class="mx-4">
                        <v-layout row wrap>
                          <v-flex xs12 class="my-2">
                            <span v-if="student.birth_certificate_submitted">
                              <v-icon style="vertical-align: middle">check_circle</v-icon>
                            </span>
                            <span v-else>
                              <v-icon style="vertical-align: middle">block</v-icon>
                            </span>
                            <span>Birth Certificate Submitted</span>
                          </v-flex>
                          <v-flex xs12 class="my-2">
                            <span v-if="student.report_card_submitted">
                              <v-icon style="vertical-align: middle">check_circle</v-icon>
                            </span>
                            <span v-else>
                              <v-icon style="vertical-align: middle">block</v-icon>
                            </span>
                            <span>Report Card Submitted</span>
                          </v-flex>
                          <v-flex xs12 class="my-2">
                            <span v-if="student.good_moral_submitted">
                              <v-icon style="vertical-align: middle">check_circle</v-icon>
                            </span>
                            <span v-else>
                              <v-icon style="vertical-align: middle">block</v-icon>
                            </span>
                            <span>Good Moral Submitted</span>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- BUTTON SECTION -->
    <v-divider class="my-3 divider-large hide-on-print">
    </v-divider>
    <v-card class="hide-on-print">
      <v-layout justify-center class="pt-4">
        <v-flex xs8 md3 class="title">
          <v-autocomplete
          class="title font-weight-black disabled-field "
          v-model="selectedSchoolYear"
          :items="schoolYears"
          item-text="school_year_display"
          return-object
          color="#091D3B"
          label="Selected School Year"
          >
        </v-autocomplete>
      </v-flex>
      </v-layout>
      <v-layout justify-center class="hdie-on-print" >
          <EnrollmentModal
            :selectedEnrollment="selectedEnrollment"
            :successCallback="refreshSelectedEnrollment"
            :previousSchoolYear="previousSchoolYear"
            ref="EnrollmentModal"
          />
      </v-layout>
    </v-card>

    <v-divider
      class="my-3 divider-large hide-on-print"
      v-if="student.is_enrolled_this_school_year"
    ></v-divider>

    <!-- END OF BUTTON SECTION -->

    <div v-if="enrollments" class="pagebreak">
      <v-layout v-if="selectedEnrollment">
        <v-flex xs12>
          <v-card class="no-shadow-print">
            <div>
              <v-toolbar flat color="white" class="pt-2" style="margin-top: 21px;">
                <!-- Desktop View -->
                <v-layout row wrap class="mt-4 hide-on-mobile">
                  <v-flex md3 class="title">
                    <v-text-field
                      label="Student Number"
                      :value="selectedEnrollment.student_number_display"
                      disabled
                      class="title font-weight-black disabled-field"
                    ></v-text-field>
                  </v-flex>
                  <v-spacer class="hide-on-mobile"></v-spacer>
                  <v-btn
                    @click="editEnrollment(selectedEnrollment)"
                    class="button-style-blue hide-on-print"
                    block
                    >Edit Enrollment
                  </v-btn>
                  <v-spacer class="hide-on-mobile"></v-spacer>
                  <v-flex md3 class="title">
                    <v-text-field
                    label="SchoolYear"
                    :value="schoolYear.name"
                    reverse
                    disabled
                    class="title font-weight-black disabled-field"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <!-- Mobile View -->
                <v-layout row wrap class="mt-4 mobile-only">
                  <v-flex xs6 class="title" style="display: inline-block">
                    <v-text-field
                      label="Student Number"
                      :value="selectedEnrollment.student_number_display"
                      disabled
                      class="title font-weight-black disabled-field"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 class="title" style="display: inline-block">
                    <v-text-field
                    label="SchoolYear"
                    :value="schoolYear.name"
                    reverse
                    disabled
                    class="title font-weight-black disabled-field"
                    >
                    </v-text-field>
                  </v-flex>
                  <v-btn
                    @click="editEnrollment(selectedEnrollment)"
                    class="button-style-blue hide-on-print"
                    block
                    >Edit Enrollment
                  </v-btn>
                </v-layout>


              </v-toolbar>
            </div>
            <v-container grid-list-md class="fluid-full" v-if="selectedEnrollment">
              <v-layout row wrap>
                <v-flex md3 xs12>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Enrollment Details</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                              label="Enrollment Date"
                              :value="selectedEnrollment.enrollment_date"
                              disabled
                              class="disabled-field-underline"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                label="Grade Level"
                                :value="gradeLevel"
                                disabled
                                class="disabled-field-underline"
                              ></v-text-field>
                            </v-flex>


                            <v-flex xs12>
                              <v-text-field
                              label="Payment Plan"
                              :value="selectedEnrollment.payment_plan_display"
                              disabled
                              class="disabled-field-underline"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-text-field
                                label="Enrollment Type"
                                :value="selectedEnrollment.enrollment_type_display"
                                disabled
                                class="disabled-field-underline"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                label="Track Type"
                                no-resize
                                :rows="selectedEnrollment.track_type == 3 ? 2 : 1"
                                :value="selectedEnrollment.track_type_display"
                                disabled
                                class="disabled-field-underline"
                              ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-textarea
                                v-model="selectedEnrollment.remarks"
                                color="#091D3B"
                                rows="1"
                                auto-grow
                                label="Remarks"
                                disabled
                                class="disabled-field-underline"
                              >
                              </v-textarea>
                            </v-flex>
                            <v-flex xs12>
                              <v-expansion-panel>
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div>Books ({{selectedEnrollment.books.length}})</div>
                                  </template>
                                  <v-card>
                                    <v-card-text v-if="selectedEnrollment.books.length >= 1">
                                      <v-layout row wrap v-for="(book) in selectedEnrollment.books">
                                        <v-flex xs12>
                                          <v-currency-field
                                            :label="book.subject"
                                            :value="book.price"
                                            prefix="₱"
                                            disabled
                                            class="disabled-field-underline"
                                          ></v-currency-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-card-text>
                                    <v-card-text v-else><span>No books available</span></v-card-text>
                                  </v-card>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-flex xs12>
                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md3 xs12>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Downpayment</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="(Previous Year's Balance)"
                                :value="selectedEnrollment.previous_year_balance"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Tuition Fee"
                                :value="selectedEnrollment.tuition_fee"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Registration Fee"
                                :value="selectedEnrollment.registration_fee"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Miscellaneous Fee"
                                :value="selectedEnrollment.miscellaneous_fee"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Books Fee"
                                :value="selectedEnrollment.total_books_fee"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Computer Fee"
                                :value="selectedEnrollment.computer_fee"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="ESC Subsidy"
                                :value="selectedEnrollment.esc_subsidy"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Discount"
                                :value="selectedEnrollment.discount"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                                prefix="₱"
                                label="Total Downpayment"
                                :value="totalDown"
                                disabled
                                class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex md3 xs12>
                  <v-card>
                    <v-toolbar flat color="white" class="pt-2">
                      <span class="title"><strong>Installment</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-text-field
                              label="Number of Installments"
                              :value="selectedEnrollment.num_installments"
                              disabled
                              class="disabled-field-underline"
                              ></v-text-field>
                            </v-flex>

                            <v-flex xs12>
                              <v-currency-field
                              prefix="₱"
                              label="Installment Amount"
                              :value="selectedEnrollment.installment_amount"
                              disabled
                              class="disabled-field-underline"
                              ></v-currency-field>
                            </v-flex>

                            <v-flex xs12 v-if="installmentBreakdown.length > 0">
                              <v-expansion-panel>
                                <v-expansion-panel-content>
                                  <template v-slot:header>
                                    <div>Breakdown</div>
                                  </template>
                                  <v-data-table
                                    :headers="headerBreakdown"
                                    :items="installmentBreakdown"
                                    class="elevation-1"
                                    hide-actions
                                    hide-headers
                                  >
                                    <template v-slot:items="props">
                                      <td>{{ props.item }} ({{ selectedEnrollment.installment_amount }})</td>
                                    </template>
                                  </v-data-table>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-flex xs12>

                          </v-layout>
                        </v-card-title>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md3 xs12>
                  <v-card class="button-style-blue">
                    <v-toolbar flat class="button-style-blue pt-2">
                      <span class="title"><strong>Total</strong></span>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-card-title class="mx-4">
                          <v-layout row wrap>
                            <v-flex xs12>
                              <v-currency-field
                              prefix="₱"
                              label="Total Paid"
                              :value="selectedEnrollment.total_paid"
                              disabled
                              class="disabled-field-underline important"
                              ></v-currency-field>
                            </v-flex>
                            <v-flex xs12>
                              <v-currency-field
                              prefix="₱"
                              label="Total Tuition"
                              :value="selectedEnrollment.total_tuition"
                              disabled
                              class="disabled-field-underline important"
                              ></v-currency-field>
                            </v-flex>
                            <!-- <v-flex xs12>
                            <v-currency-field
                            prefix="₱"
                            label="Previous Balance"
                            :value="selectedEnrollment.previous_year_balance"
                            disabled
                            class="disabled-field-underline important"
                            ></v-currency-field>
                          </v-flex> -->
                          <v-flex xs12>
                            <v-currency-field
                            prefix="₱"
                            label="Remaining Balance"
                            :value="totalBalance"
                            disabled
                            class="disabled-field-underline important"
                            ></v-currency-field>
                          </v-flex>
                        </v-layout>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  </v-card>
                </v-flex>

              </v-layout>
              <v-layout style="padding-top: 50px;" class="hide-on-view">
                <v-toolbar flat color="white" class="pt-2">
                  <v-flex xs6>
                    <v-text-field
                      label="Signature"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-toolbar>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout v-if="selectedEnrollment" class="hide-on-print">
        <v-flex>
          <div>
            <v-toolbar flat color="white" class="pt-2">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-toolbar-title>Payments</v-toolbar-title>
                </v-flex>

                <v-spacer></v-spacer>
                <PaymentModal
                  v-if="selectedEnrollment"
                  noButton
                  :successCallback="paymentModalSuccessCallback"
                  :enrollment="selectedEnrollment"
                  ref="PaymentModal"
                />
                <v-btn
                  class="button-style-blue ml-0"
                  dark
                  @click="addPayment"
                  >
                  Add Payment <v-icon dark right>add</v-icon>
                </v-btn>
              </v-layout>
            </v-toolbar>
            <v-data-table :headers="headers" item-key="name" :items="payments">
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.or_number_display }}</td>
                  <td>{{ currencyFormat(props.item.amount) }}</td>
                  <td>{{ props.item.payment_for }}</td>
                  <td>{{ props.item.collected_date }}</td>
                  <td>{{ props.item.collected_by }}</td>
                  <td>
                    <v-btn
                      @click="editPayment(props.item)"
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="green darken-4"
                        size="15px"
                      >
                        edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      @click="removePayment(props.item)"
                      color="light-gray"
                      :icon="true"
                    >
                      <v-icon
                        color="red darken-4"
                        size="15px"
                      >
                        delete
                      </v-icon>
                    </v-btn>
                </td>
                </tr>
              </template>
            </v-data-table>
            <v-toolbar flat color="white" class="pt-2">
              <v-spacer></v-spacer>
              <v-btn
                class="button-style-blue"
                dark
                @click="addPayment"
              >
                Add Payment <v-icon dark right>add</v-icon>
              </v-btn>
            </v-toolbar>
          </div>
        </v-flex>
      </v-layout>

      <v-layout v-if="selectedEnrollment" class="hide-on-print">
        <v-flex>
          <v-expansion-panel v-model="historyPanel" expand>
            <v-expansion-panel-content>
              <template v-slot:header>
                <div>Message History</div>
              </template>
              <template>
                <v-data-table
                  :headers="historyHeaders"
                  :items="message_history"
                  class="elevation-1"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.sender }}</td>
                    <td>{{ props.item.recipient }}</td>
                    <td>{{ props.item.body }}</td>
                    <td>{{ props.item.grade_level }}</td>
                  </template>
                </v-data-table>
              </template>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</div>
</template>
<style media="screen">
.hide-on-view {
  display: none!important;
}
@media print {
  @page {
    size: auto;
    margin: 0;
    margin-bottom: 0mm!important;
  }
  * {
    margin: 0!important;
  }
  .pagebreak { page-break-before: auto; break-after: auto; }
  .container {
    margin: 0!important;
    padding: 0!important;
  }
  .container-style {
    border: none!important;
    box-shadow: none!important;
    background-color: unset!important;
    margin: 0!important;
  }
  .container.fluid {
    max-width: 100%!important;
  }
  .hide-on-view {
    display: block!important;
  }
  .container-header, .hide-on-print, #Header, #Footer {
    display: none!important;
  }
  .container.grid-list-md .layout .flex {
    width: 100%!important;
  }
  .no-shadow-print {
    box-shadow: none!important;
  }
}
</style>
<script type="text/javascript">

import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'
import PaymentModal from '@/components/PaymentModal.vue'
import EnrollmentModal from '@/components/EnrollmentModal.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'



export default {
  components: {
    Header,
    EnrollmentModal,
    PaymentModal,
    LoadingDialog
  },
  computed: {
    ...mapState([
      'student',
      'schoolYear',
      'enrollments',
      'payments',
      'payment',
      'enrollment',
      'schoolYears',
    ]),
    computeAge () {
      if (this.student.birthday) {
        const date_by_june = this.$moment().month(5)
        const student_birthday_by_june = this.$moment.duration(this.$moment(date_by_june).diff(this.student.birthday));
        return this.student.birthday + " ("+student_birthday_by_june.years() + " years, " + student_birthday_by_june.months() + " months)"
      } else {
        return
      }
    },
    installmentBreakdown () {
      if (this.selectedEnrollment.payment_plan == 1) {
        return (['July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'])
      } else if (this.selectedEnrollment.payment_plan == 2) {
        return (['September', 'December', 'March'])
      } else if (this.selectedEnrollment.payment_plan == 3) {
        return (['November'])
      } else {
        return []
      }
    },
    totalBalance () {
      return (
        (this.selectedEnrollment.total_balance ? parseFloat(this.selectedEnrollment.total_balance): 0)).toFixed(2);
    },
    totalDown () {
      return (
        (this.selectedEnrollment.previous_year_balance ? parseFloat(this.selectedEnrollment.previous_year_balance): 0) +
        (this.selectedEnrollment.tuition_fee ? parseFloat(this.selectedEnrollment.tuition_fee): 0) +
        (this.selectedEnrollment.registration_fee ? parseFloat(this.selectedEnrollment.registration_fee) : 0) +
        (this.selectedEnrollment.miscellaneous_fee ? parseFloat(this.selectedEnrollment.miscellaneous_fee) : 0) +
        (this.selectedEnrollment.computer_fee ? parseFloat(this.selectedEnrollment.computer_fee) : 0) +
        (this.selectedEnrollment.total_books_fee ? parseFloat(this.selectedEnrollment.total_books_fee) : 0) -
        (this.selectedEnrollment.esc_subsidy ? parseFloat(this.selectedEnrollment.esc_subsidy) : 0) -
        (this.selectedEnrollment.discount ? parseFloat(this.selectedEnrollment.discount) : 0)
      ).toFixed(2);
    },
    gradeLevel () {
      return (
        (this.selectedEnrollment.grade_level_display + " / " + this.selectedEnrollment.department_display)
      )
    },
    parentPortalUrl () {
      return(
        ('https://parent.gingergraceacademe.com/'+this.selectedEnrollment.student_number_display+":"+this.student.birthday)
      )
    },
  },
  watch: {
    selectedSchoolYear: function (selectedSchoolYear) {
      this.setSelectedSchoolYear(selectedSchoolYear)
      this.getPreviousSchoolYear(selectedSchoolYear)
      this.initialize()
    },
  },
  data() {
    return {
      historyPanel: [true],
      valid: true,
      department: '',
      previousSchoolYear: null,
      selectedEnrollment: null,
      selectedSchoolYear: null,
      forPreviousBalance: null,
      message_history: [],
      headerBreakdown: [
        {
          text: 'Month',
          align: 'left',
          sortable: false,
          width: '100%'
        },
      ],
      headers: [
        {
          text: 'OR #',
          sortable: false,
        },
        {
          text: 'Amount',
          sortable: false,
        },
        {
          text: 'Payment For',
          sortable: false,
        },
        {
          text: 'Collected Date',
          sortable: false,
        },
        {
          text: 'Collected By',
          sortable: false,
        },
        {
          text: '',
          sortable: false,
          width: '15%'
        }

      ],
      historyHeaders: [
        {
          value: 'sender',
          text: 'Sender'
        },
        {
          value: 'recipient',
          text: 'Recipient'
        },
        {
          value: 'body',
          text: 'Body',
          sortable: false,
        },
        {
          value: 'grade_level',
          text: 'Grade Level'
        }
      ],
    }
  },
  methods: {
    ...mapActions([
      'deletePayment',
      'getStudentById',
      'getEnrollments',
      'getPaymentsByEnrollmentId',
      'getEnrollmentById',
      'getPaymentByID',
      'getSchoolYears',
      'setSelectedSchoolYear',
      'getSMSHistory',
    ]),
    currencyFormat (amount) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return formatter.format(amount)
    },
    getPreviousSchoolYear (selectedSchoolYear) {
      for (let count = 0; count < this.schoolYears.length; count++) {
        if (selectedSchoolYear.id == this.schoolYears[count].id){
          this.previousSchoolYear = this.schoolYears[count+1]
        }
      }
    },
    addPayment () {
      this.$refs.LoadingDialog.dialog = true
      this.getEnrollmentById({id: this.selectedEnrollment.id})
        .then((data) => {
          this.$refs.PaymentModal.dialog = true
          this.$refs.PaymentModal.selectedEnrollment = this.enrollment
          this.$refs.LoadingDialog.dialog = false
        })
    },
    editPayment(payment) {
      this.$refs.LoadingDialog.dialog = true
      Promise.all([this.getEnrollmentById({id: payment.enrollment}), this.getPaymentByID(payment.id)])
        .then((data) => {
          this.$refs.PaymentModal.newPayment = this.payment
          this.$refs.PaymentModal.oldPayment = JSON.parse(JSON.stringify(this.payment))
          this.$refs.PaymentModal.selectedEnrollment = this.enrollment
          this.$refs.PaymentModal.dialog = true

          this.$refs.LoadingDialog.dialog = false
        })
    },
    editEnrollment (enrollment) {
      this.getEnrollmentById(this.selectedEnrollment)
        .then((data) => {
          this.$refs.EnrollmentModal.newEnrollment = Object.assign(data)
          this.$refs.EnrollmentModal.dialog = true
        })
        .catch((data) => {

        })
    },
    removePayment (payment) {
      if (confirm('Are you sure you want to delete this payment?')) {
        this.deletePayment(payment)
          .then((data) => {
            this.initialize()
          })
      }
    },
    updateStudent () {
      this.$router.push({ name: 'update-student', params: {id: this.$route.params.id} })
    },
    refreshSelectedEnrollment () {
      this.getStudentById({ id: this.$route.params.id })
        .then(() => {
          this.getEnrollments({school_year: this.selectedSchoolYear.id, student: this.$route.params.id})
            .then(() => {
              if (this.enrollments.length) {
                this.selectedEnrollment = this.enrollments[0]
                if (this.selectedEnrollment.id) {
                  this.getPaymentsByEnrollmentId({ enrollmentId: this.selectedEnrollment.id  })
                }
              } else {
                this.selectedEnrollment = null
              }
            })
        this.$refs.LoadingDialog.dialog = false
        });
    },
    SMSHistory () {
      this.getSMSHistory({student: this.$route.params.id})
        .then((data) => {
          this.message_history = data.message_history
        })
        .catch(() => {

        })
        this.$refs.LoadingDialog.dialog = false
    },
    cancel() {
      this.$router.push({
        name: 'student-list'
      });
    },
    print() {
      window.print();
    },
    paymentModalSuccessCallback () {
      this.$toastr('success', 'Action success', 'Success')
      this.initialize()
    },
    initialize () {
      this.SMSHistory()
      this.$refs.LoadingDialog.dialog = true
      this.refreshSelectedEnrollment()
    },
  },
  created() {
    this.getSchoolYears()
      .then((data) => {
        for (let count = 0; count < this.schoolYears.length; count++) {
          if (this.schoolYears[count].is_open) {
            this.selectedSchoolYear = this.schoolYears[count]
          }
        }
      })
      .catch((data) => {

      })
  },

}
</script>
